import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "absolute top-0 left-0 right-0 bottom-0 flex"
};
const _hoisted_2 = {
  class: "w-full h-full"
};
import Left from './components/Left.vue';
import Write from './components/Write.vue';
import Right from './components/Right.vue';
import { AiMindMapApi } from '@/api/ai/mindmap';
import { MindMapContentExample } from '@/views/aip/utils/constants';
import { nextTick, onMounted, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'AiMindMap'
  },
  __name: 'index',
  setup(__props) {
    const ctrl = ref(); // 请求控制
    const isWriting = ref(false); // 是否正在写作中
    const isGenerating = ref(false); // 是否正在生成思维导图
    const isStart = ref(false); // 开始生成，用来清空思维导图
    const isEnd = ref(true); // 用来判断结束的时候渲染思维导图
    const message = useMessage(); // 消息提示
    const generatedContent = ref(''); // 生成思维导图结果
    const leftRef = ref(); // 左边组件
    const writeRef = ref(); // 右边组件
    const rightRef = ref(); // 右边组件
    /** 使用已有内容直接生成 **/
    const directGenerate = existPrompt => {
      isEnd.value = false; // 先设置为 false 再设置为 true，让子组建的 watch 能够监听到
      generatedContent.value = existPrompt;
      isEnd.value = true;
      isWriting.value = true;
    };
    /** 停止 stream 生成 */
    const stopStream = () => {
      isGenerating.value = false;
      isStart.value = false;
      ctrl.value?.abort();
    };
    /** 提交生成 */
    const submit = data => {
      isWriting.value = true;
      isGenerating.value = true;
      isStart.value = true;
      isEnd.value = false;
      ctrl.value = new AbortController(); // 请求控制赋值
      generatedContent.value = ''; // 清空生成数据
      AiMindMapApi.generateMindMap({
        data,
        onMessage: async res => {
          const {
            code,
            data,
            msg
          } = JSON.parse(res.data);
          if (code !== 0) {
            message.alert(`生成思维导图异常! ${msg}`);
            stopStream();
            return;
          }
          generatedContent.value = generatedContent.value + data;
          await nextTick();
          writeRef.value?.scrollBottom();
        },
        onClose() {
          isEnd.value = true;
          leftRef.value?.setGeneratedContent(generatedContent.value);
          stopStream();
        },
        onError(err) {
          console.error('生成思维导图失败', err);
          stopStream();
          // 需要抛出异常，禁止重试
          throw err;
        },
        ctrl: ctrl.value
      });
    };
    const handleWriteClose = () => {
      isWriting.value = false;
      rightRef.value?.loadWriteList();
    };
    /** 初始化 */
    onMounted(() => {
      generatedContent.value = MindMapContentExample;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Left, {
        ref_key: "leftRef",
        ref: leftRef,
        "is-generating": isGenerating.value,
        onSubmit: submit,
        onDirectGenerate: directGenerate
      }, null, 8, ["is-generating"]), _createElementVNode("div", _hoisted_2, [isWriting.value ? (_openBlock(), _createBlock(Write, {
        key: 0,
        ref_key: "writeRef",
        ref: writeRef,
        generatedContent: generatedContent.value,
        isEnd: isEnd.value,
        isGenerating: isGenerating.value,
        isStart: isStart.value,
        onHandleClose: handleWriteClose
      }, null, 8, ["generatedContent", "isEnd", "isGenerating", "isStart"])) : (_openBlock(), _createBlock(Right, {
        key: 1,
        ref_key: "rightRef",
        ref: rightRef,
        class: "flex-grow"
      }, null, 512))])]);
    };
  }
});